module.exports = __webpack_public_path__ + "img/emoji-documents@3x.485123f.png";